import ModuleTemplatesContainer from './module-templates-container';

export default ModuleTemplatesContainer;